/**
 * @generated SignedSource<<c1f07fdc6f1b18271cd343634fa1d41f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateMeetingProviderFormFragment$data = {
  readonly id: string;
  readonly meetingProviders: {
    readonly __id: string;
    readonly totalCount: number;
  } | null;
  readonly name: string;
  readonly unlinkedZoomConnections: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly email: string | null;
        readonly firstName: string | null;
        readonly id: string;
        readonly lastName: string | null;
        readonly picUrl: string | null;
      };
    }>;
  } | null;
  readonly " $fragmentType": "CreateMeetingProviderFormFragment";
};
export type CreateMeetingProviderFormFragment$key = {
  readonly " $data"?: CreateMeetingProviderFormFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateMeetingProviderFormFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateMeetingProviderFormFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "platform",
          "value": "zoom"
        }
      ],
      "concreteType": "MeetingProviderNodeConnection",
      "kind": "LinkedField",
      "name": "meetingProviders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": "meetingProviders(platform:\"zoom\")"
    },
    {
      "alias": "unlinkedZoomConnections",
      "args": null,
      "concreteType": "ZoomConnectionNodeConnection",
      "kind": "LinkedField",
      "name": "viewerUnlinkedZoomConnections",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ZoomConnectionNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ZoomConnection",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "picUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "552bb4ceb5b2f31db4da237ad6d4abc9";

export default node;
